import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/OurValues.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox' // Добавлен импорт

class OurValues extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lightboxController: { // Добавлено состояние для лайтбокса
        toggler: false,
        slide: 1,
        sources: []
      }
    }
  }

  // Добавлен обработчик для открытия лайтбокса
  openLightbox = (sources, index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1,
        sources: sources
      }
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data } = this.props
    const { lightboxController } = this.state // Получаем состояние лайтбокса

    // Собираем все изображения для лайтбокса
    const allImages = [
      ...(data?.blocks?.map(block => block.full || block.image) || []),
      ...(data?.keys?.filter(key => key.image !== '').map(key => key.full || key.image) || [])
    ]

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.rtext || ``}
            className={styles.title}
          />
          
          {/* Добавлен компонент лайтбокса */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={lightboxController.sources.length > 0 ? lightboxController.sources : allImages}
            slide={lightboxController.slide}
          />

          <div className={styles.content}>
            {data?.blocks.map( ( elm, k ) => {
              if( k == 0 ) return (
                <div key={k} className={styles.felm}>
                  {/* Добавлен обработчик клика для открытия лайтбокса */}
                  <div>
                    <Image src={elm.image} width={386} height={417} alt={`GOODWIN`} />
                  </div>
                  <div className={styles.felm_text}>
                    <div className={styles.felm_tline}>
                      <div className={styles.felm_tline_title} dangerouslySetInnerHTML={{__html: elm?.name}} />
                      <div>[GOODWIN]</div>
                    </div>
                    <div className={styles.felm_text_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  </div>
                </div>
              )
            } )}
            <div className={styles.right}>
              {data?.blocks.map( ( elm, k ) => {
                if( k > 0 ) return (
                  <div key={k} className={styles.elm}>
                    {/* Добавлен обработчик клика для открытия лайтбокса */}
                    <div onClick={() => this.openLightbox(allImages, k)} style={{cursor: 'pointer'}}>
                      <Image src={elm.image} width={387} height={169} alt={elm?.name} />
                    </div>
                    <div className={styles.elm_content}>
                      <div className={styles.elm_tline}>
                        <div className={styles.elm_title} dangerouslySetInnerHTML={{__html: elm?.name}} />
                        <div className={styles.elm_sep}></div>
                        <div className={styles.elm_num}>{this.formatSlideNumber( k - 1 )}</div>
                      </div>
                      <div className={styles.elm_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                    </div>
                  </div>
                )
              } )}
            </div>
          </div>
          <div className={styles.keys}>
              {data?.keys.map( ( elm, k ) => (
                <div key={k} className={`${elm.image != '' ? styles.kelm : styles.kelm_light}`}>
                  {elm.image != '' &&
                    /* Добавлен обработчик клика для открытия лайтбокса */
                    <div onClick={() => this.openLightbox(allImages, data?.blocks.length + k)} style={{cursor: 'pointer'}}>
                      <Image className={styles.kelm_image} src={elm.image} width={287} height={158} alt={elm?.name} />
                    </div>
                  }
                  <div className={styles.kelm_content}>
                    {elm?.rating != '' ?
                      <div className={styles.kelm_ratingline}>
                        <div className={styles.kelm_ratingline_left}>
                          <a className={styles.kelm_href} href={elm?.href}>
                            <GreenButton
                              text={`Смотреть`}
                              width={106}
                            />
                          </a>
                          <Image className={styles.kelm_rimage} src={elm.rimage} width={57} height={35} alt={elm?.name} />
                        </div>
                        <div className={styles.kelm_ratingline_sep}></div>
                        <div className={styles.kelm_rating}>
                          <div className={styles.kelm_rating_title}>
                            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.5 0L7.95934 4.49139H12.6819L8.86126 7.26722L10.3206 11.7586L6.5 8.98278L2.6794 11.7586L4.13874 7.26722L0.318133 4.49139H5.04066L6.5 0Z" fill="#00C775"/>
                            </svg>
                            {elm?.rating}
                          </div>
                          <div>Рейтинг GW</div>
                        </div>
                      </div>
                    :
                      <>
                        {elm?.href != '' &&
                          <a className={styles.kelm_href} href={elm?.href}>
                            <GreenButton
                              text={`Смотреть`}
                              width={106}
                            />
                          </a>
                        }
                      </>
                    }
                    <div className={styles.kelm_title}>{elm?.name}</div>
                    <div className={styles.kelm_tline}>
                      <div>GOODWIN</div>
                      <div className={styles.kelm_sep}></div>
                      <div>{this.formatSlideNumber( k )}</div>
                    </div>
                  </div>
                </div>
              ) )}
          </div>
        </Container>
      </section>
    )
  }
}

OurValues.propTypes = {
  data: PropTypes.object
}

OurValues.defaultProps = {
  data: {}
}

export default OurValues